// extracted by mini-css-extract-plugin
module.exports = {"imageWrap":"_682ae379","image":"_4195e00d","wrapper":"_53b8be39","name":"_c4c48f8d","arrow":"_487fde33"};